import { DIALOG_SCROLL_STRATEGY } from '@angular/cdk/dialog';
import { ScrollStrategyOptions } from '@angular/cdk/overlay';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, isDevMode } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';

import { ENVIRONMENT, authInterceptor } from '@instaclause-webapp/shared-core';
import { provideTransloco } from '@jsverse/transloco';
import { provideTranslocoPersistLang } from '@jsverse/transloco-persist-lang';
import {
  TimeagoCustomFormatter, TimeagoFormatter, TimeagoIntl, TimeagoModule,
} from 'ngx-timeago';

import { environment } from '../environments/environment';

import { appRoutes } from './app.routes';
import { apiBaseUrl } from './core/api/api.service';
import { TranslocoHttpLoader } from './transloco-loader';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(appRoutes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([ authInterceptor ])),
    provideTransloco({
      config: {
        availableLangs: [ 'en', 'nl', 'be-nl', 'fr' ],
        defaultLang: 'en',
        fallbackLang: 'nl',
        missingHandler: { useFallbackTranslation: true },
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader,
    }),
    provideTranslocoPersistLang({
      storage: {
        useValue: localStorage,
      },
    }),
    importProvidersFrom(
      TimeagoModule.forRoot({
        intl: {
          provide: TimeagoIntl,
        },
        formatter: {
          provide: TimeagoFormatter,
          useClass: TimeagoCustomFormatter,
        },
      }),
    ),
    {
      provide: DIALOG_SCROLL_STRATEGY,
      useFactory: (scrollStrategyOptions: ScrollStrategyOptions) =>
        scrollStrategyOptions.block,
      deps: [ ScrollStrategyOptions ],
    },
    {
      provide: ENVIRONMENT,
      useValue: environment,
    },
    {
      provide: apiBaseUrl,
      useValue: environment.apiBaseUrl,
    },
  ],
};
